import { createAction, props } from '@ngrx/store';
import { BillingitemPackageRequestV26 } from 'src/app/models-v26/billingitem-v26';
import { ActionResponse } from 'src/app/models/action-response';
import { AddBillingitemTopackageDueDates } from 'src/app/shared-components/allocation-wizard-modal-dialogs/add-billingitems-topackage-wizard/init-step/addbillingitems-due-date-info';
import { AddBillingitemTopackageInitStep } from 'src/app/shared-components/allocation-wizard-modal-dialogs/add-billingitems-topackage-wizard/init-step/init-step';

export const selectInitStep = createAction(
  '[V26 Catalog Page] Select Init Add BillingitemTopackage Information Step',
  props<{ initStep: AddBillingitemTopackageInitStep }>(),
);

export const selectDueDatesStep = createAction(
  '[V26 Wizard Due Date Step] Select Add BillingitemTopackage Due Date Step',
  props<{ dueDatesStep: AddBillingitemTopackageDueDates }>(),
);

export const exitAddBillingitemTopackageWizard = createAction(
  '[V26 AddBillingitemTopackage Wizard Page] Exit Add BillingitemTopackage Wizard',
);

export const destroyWizard = createAction('[V26 AddBillingitemTopackage Wizard Page] Destroy Wizard');

export const createNewAddBillingitemTopackage = createAction(
  '[V26 Wizard Confirmation Step] Create Add BillingitemTopackage Information Step',
  props<{ request: BillingitemPackageRequestV26 }>(),
);

export const createNewAddBillingitemTopackageSuccess = createAction(
  '[V26 Wizard Confirmation Step] Create Add BillingitemTopackage Information Step Success',
  props<{ response: ActionResponse }>(),
);

export const createNewAddBillingitemTopackageFail = createAction(
  '[V26 Wizard Confirmation Step] Create Add BillingitemTopackage Information Step Fail',
  props<{ errorMessage: string }>(),
);
